import * as React from 'react';

const InfoCircleFilled24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 1.526c5.522 0 10 4.479 10 10.001 0 5.523-4.478 10-10 10s-10-4.477-10-10 4.477-10 10-10Zm0 8.5a1 1 0 0 0-1 1v4.5a1 1 0 1 0 2 0v-4.5a1 1 0 0 0-1-1m0-4.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
  }
));
InfoCircleFilled24.Size = 24;
InfoCircleFilled24.Title = "InfoCircleFilled";

export { InfoCircleFilled24 as default };
